module.exports = __webpack_public_path__ + "img/genswell_2_1.d34cad10.png";